<template>
  <div class="settings-group-item" :class="{ small }">
    <div>
      <div class="text-h6">{{ label }}</div>
      <div class="description grey--text">{{ description }}</div>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettingsGroupItem',
  props: {
    label: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: null,
    },
  },
  computed: {
    small() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style lang="scss" scoped>
.settings-group-item {
  display: grid;
  gap: 16px;
  grid-template-columns: 400px 1fr;

  &.small {
    grid-template-columns: 1fr 1fr;
  }
}
.description {
  line-height: 175%;
}
</style>
